module.exports = {
    redirect: function(url, type) {
        var redirectUrl = ''
        if (type) {
            var localurl = location.href.split("?")[0]
            redirectUrl = localurl.substring(0, localurl.lastIndexOf('/')) + url;
        } else {
            redirectUrl = location.href.substring(0, location.href.lastIndexOf('/')) + url;
        }
        location.href = redirectUrl;

    },

    //日期格式化
    formatterDate: function(str, patten) {
        Date.prototype.format = function(format) {
                var o = {
                    "M+": this.getMonth() + 1, //month
                    "d+": this.getDate(), //day
                    "w+": this.getDay(), //day of week
                    "h+": this.getHours(), //hour
                    "m+": this.getMinutes(), //minute
                    "s+": this.getSeconds(), //second
                    "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
                    "S": this.getMilliseconds() //millisecond
                }
                if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
                    (this.getFullYear() + "").substr(4 - RegExp.$1.length));
                for (var k in o)
                    if (new RegExp("(" + k + ")").test(format))
                        format = format.replace(RegExp.$1,
                            RegExp.$1.length == 1 ? o[k] :
                            ("00" + o[k]).substr(("" + o[k]).length));
                return format;
            }
            // var d = new Date();
            // var useDate2 = d.format('yyyy-MM-dd hh:mm:ss');
        let d = new Date(str)
        let result = d.format(patten)
        return result;
    },

    //获取星期几
    getDayOfWeek(data) {
        let myddy = data.getDay(); //获取存储当前日期
        let weekday = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
        return weekday[myddy];
    },

    /**
     * 获取已发布时间 
     * @param {*} str 发布时间
     * @returns 
     */
    publishedTime: function(str) {
        // console.log("pubtime " + str * 1000)
        str = str * 1000

        let d = new Date().getTime();
        let pubedTime = d - str; //获取已经发布时间

        // console.log("pubedtime " + pubedTime + "\n\t")
        let pubHourMin = Math.round(pubedTime / 3600 / 60 / 24 * 100) / 100; //转时间
        let h = pubHourMin.toString().split('.')[0];
        let m = pubHourMin.toString().split('.')[1] * 60 / 100; //转分钟

        if (h > 0 && h < 24)
            return h + '小時前';
        else if (h <= 0)
            return Math.round(m) + '分鐘前';
        else if (h >= 24 && h < 24 * 7) {
            return Math.round(h / 24) + '天前';
        } else if (h > 24 * 7) {
            return module.exports.formatterDate(str, 'yyyy年MM月dd日')
        }
    },

    /**
     * 获取标题中文
     * @param {*} nl 导航集合
     * @param {*} navId 当前文章categoryId
     * @returns 
     */
    getNavName(nl, categoryId) {

        for (let i = 0; i < nl.length; i++)
            if (nl[i].categoryId == categoryId) {
                return nl[i].categoryName;
            }
        return '';

    },

    /**
     * 获取当前页最后一篇文章id
     * @param {*} newList 当前新闻列表
     * @returns 
     */
    getLastNewsId(newList) {
        return newList[newList.length - 1].id;
    },

    /**
     * 获取url中的参数
     * @param {*} location 
     */
    getUrlParam2(location) {
        var url = location.search //获取url中"?"符后的字串 ('?modFlag=business&role=1')
        var theRequest = new Object()
        if (url.indexOf('?') != -1) {
            var str = url.substr(1) //substr()方法返回从参数值开始到结束的字符串；
            var strs = str.split('&')
            for (var i = 0; i < strs.length; i++) {
                theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1]
            }
            // console.log(theRequest) //此时的theRequest就是我们需要的参数；
            // console.log(theRequest.type)
        }
        return theRequest;

    },

    //获取页面参数
    getUrlParam: function(key) {
        var re = "/^.*[\\?|\\&]" + key + "\\=([^\\&]*)/",
            url = location.href;
        re = eval(re);
        var ret = url.match(re);
        if (ret != null) {
            return decodeURIComponent(ret[1]);
        } else {
            return "";
        }
    },

    // 百度统计
    tongji:function () {  
        var _hmt = _hmt || [];
        (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?d7dd854f11f508947f86ec71ab1bc4b5";
        var s = document.getElementsByTagName("head")[0]; 
        s.appendChild(hm)
        })();
    }

}


// WEBPACK FOOTER //
// ./src/list/js/util.js